export default __webpack_public_path__ + "static/media/tree8.9a85584c.png";